export const removeExtraSpaces = (text?: string) => {
  return (text || '').replace(/ +(?= )/g, '').trim()
}
